module.exports = __webpack_public_path__ + "static/media/1-1-1.33934d87.webp";